module.exports = {
	"name": "olwel-admin",
	"version": "2.2.1",
	"private": true,
	"dependencies": {
		"immutable": "^3.8.2",
		"install": "^0.8.7",
		"material-ui": "^0.17.1",
		"moment": "^2.20.1",
		"npm": "^4.4.4",
		"prop-types": "^15.5.4",
		"react": "^15.5.4",
		"react-addons-shallow-compare": "^15.6.2",
		"react-dates": "^16.2.1",
		"react-dom": "^15.5.4",
		"react-helmet": "^5.2.1",
		"react-pdf": "^3.0.5",
		"react-redux": "5.0.2",
		"react-router": "3.0.2",
		"react-select": "^1.0.0-rc.5",
		"react-table": "^6.5.1",
		"react-tap-event-plugin": "2.0.1",
		"react-tooltip": "^4.2.6",
		"recharts": "^1.1.0",
		"redux": "3.6.0",
		"redux-logger": "^2.10.2",
		"redux-promise-middleware": "^4.2.0",
		"socket.io-client": "^1.7.4",
		"underscore.string": "^3.3.5",
		"whatwg-fetch": "^2.0.3"
	},
	"devDependencies": {
		"react-scripts": "1.1.2"
	},
	"scripts": {
		"start": "PORT=4000 react-scripts start",
		"staging": "REACT_APP_NODE_ENV=staging react-scripts start",
		"staging-build": "REACT_APP_NODE_ENV=staging react-scripts build",
		"build": "REACT_APP_NODE_ENV=production react-scripts build",
		"test": "react-scripts test --env=jsdom",
		"eject": "react-scripts eject",
		"push-prod": "rsync -avz --delete --rsh=ssh build server.olwel.com:/var/www/admin/current"
	}
};


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 1053
// module chunks = 2